<div class="boxPlan__header boxPlan__header__drawer">
    @if (synopticPlanInteractionService.currentPage()) {
        <button
            class="cursor-pointer"
            (click)="synopticPlanInteractionService.updateDrawerPage('prev')">
            <fa-icon [icon]="['far', 'arrow-left']" />
        </button>
    }

    <div>
        <div
            class="boxPlan__header__drawer__title boxPlan__header__title boxPlan__header__drawer__title__detailsActive">
            <span>{{ 'synopticPlan.drawer' | transloco }}</span>
            <span>{{ synopticPlanInteractionService.drawerValue() }}</span>
        </div>

        <div class="boxPlan__header__drawer__details boxPlan__header__details">
            <div class="boxPlan__header__details__content">
                <div>
                    <p>{{ 'synopticPlan.externalCode' | transloco }}</p>
                    <p>
                        {{ this.selectedNode().dataNode.externalCode || 'N/A' }}
                    </p>
                </div>
                <div>
                    <p>{{ 'synopticPlan.nbEmptyDrawer' | transloco }}</p>
                    <p>
                        {{ drawerUnmaterialized() }}
                    </p>
                </div>

                <div>
                    <p>{{ 'synopticPlan.numberOfCassettes' | transloco }}</p>
                    <p>
                        {{ drawerCount() }}
                    </p>
                </div>
                <div>
                    <p>{{ 'synopticPlan.bayPosition' | transloco }}</p>
                    <p>{{ drawerPosition() }}</p>
                </div>
                <div>
                    <p>{{ 'synopticPlan.size' | transloco }}</p>
                    <p>{{ drawerSize() }}</p>
                </div>
            </div>
        </div>
    </div>

    @if (synopticPlanInteractionService.currentPage() !== drawerCount() - 1) {
        <button
            class="cursor-pointer"
            (click)="synopticPlanInteractionService.updateDrawerPage('next')">
            <fa-icon [icon]="['far', 'arrow-right']" />
        </button>
    }
</div>
